/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
// import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import './job.css';
import AuthCheckComponent from '../../Layouts/Token';
import ls from "local-storage";
import { EditorState, RichUtils, convertToRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import PageLoader from '../../Layouts/PageLoader';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';



// const iniJob = {
//     jobtitle: "",
//     jobdescription: "",
//     roleresponsibilities: "",
//     exprequire: "",
//     minqualification: "",
//     jobactive: "",
//     numofvacanciese: '',
//     Companyprofile: "",

// }


const CreateTask = (props) => {
    const classes = props;
    // const [jobportal, setJobPortal] = useState(iniJob);
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);
    // const [qualifications, setQualifications] = useState([]);
    // const [Experience, setExperience] = useState([]);
    const [taskData, setTaskData] = useState({
        task: '',
        project_name: '',
        developer_name: '',
        task_date_time: '',
        description: '',
        status: '',
        task_deliver_date: '',
    });
    const [developers, setDevelopers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [subTasks, setSubTasks] = useState([]);
    const [showSubTaskFields, setShowSubTaskFields] = useState(false);
    const [newSubTask, setNewSubTask] = useState({ name: '', status: '' });
    const [subTaskEditorState, setSubTaskEditorState] = useState(() => EditorState.createEmpty());
    const [subTaskFields, setSubTaskFields] = useState([{ name: '', status: '', editorState: EditorState.createEmpty() }]);
    const [showSubTasks, setShowSubTasks] = useState(false);

    useEffect(() => {
        const loadInitialData = async () => {
            setPageLoading(true);
            try {
                await Promise.all([fetchDevelopers(), fetchProjects()]);
            } finally {
                setPageLoading(false);
            }
        };
        if (props && props.authToken === false) {
            // props.history.push('/login');
        }
        loadInitialData();
    }, []);


    const fetchDevelopers = async () => {
        try {
            const response = await AuthApi.getData();
            if (response) {
                const loggedUsers = response.data.filter(user => user.user_logged === 1);
                setDevelopers(loggedUsers);
            } else {
                console.error("Failed to fetch users");
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    const fetchProjects = async () => {
        try {
            const response = await AuthApi.getProject();
            if (response && response.status && Array.isArray(response.data)) {
                const activeProjects = response.data.filter(project => project.status === 1);
                setProjects(activeProjects);
            } else {
                console.error("Failed to fetch projects");
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "developer_name") {
            const selectedDeveloper = developers.find(dev => dev.firstName === value);
            setTaskData({
                ...taskData,
                developer_name: value,
                developer_user_id: selectedDeveloper ? selectedDeveloper.id : ''
            });
        } else {
            setTaskData({ ...taskData, [name]: value });
        }
        // console.log(ticketValues);
        // getQualificationData();
    };

    const validate = (values) => {
        let errors = {};
        const regex = /^[a-zA-Z]/;
        const ds = /^[0-9\b]+$/;
        // const dateR = /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/;

        if (!values.task) {
            errors.task = "Task name is required";
        }
        if (!values.project_name) {
            errors.project_name = "Project name is required";
        }
        if (!values.task_date_time) {
            errors.task_date_time = "Task date and time are required";
        }
        if (!values.description) {
            errors.description = "Description is required";
        }
        if (!values.status) {
            errors.status = "Status is required";
        }
        return errors;
    };

    const handleAddSubTaskField = () => {
        setSubTaskFields([...subTaskFields, { name: '', status: '', editorState: EditorState.createEmpty() }]);
    };

    const handleSubTaskFieldChange = (index, field, value) => {
        const updatedFields = subTaskFields.map((subTask, i) => 
            i === index ? { ...subTask, [field]: value } : subTask
        );
        setSubTaskFields(updatedFields);
    };

    const handleSubTaskEditorChange = (index, state) => {
        const updatedFields = subTaskFields.map((subTask, i) => 
            i === index ? { ...subTask, editorState: state } : subTask
        );
        setSubTaskFields(updatedFields);
    };

    const handleRemoveSubTaskField = (index) => {
        setSubTaskFields(subTaskFields.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const newSubTasks = subTaskFields.map(subTask => ({
            name: subTask.name,
            status: subTask.status,
            details: JSON.stringify(convertToRaw(subTask.editorState.getCurrentContent()))
        }));
        setSubTasks(newSubTasks);

        const errors = validate(taskData);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await createTask(newSubTasks);
    };


    const createTask = async (subTasksPayload) => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            content: createSwalLoaderNode()
        });

        try {
            const taskPayload = {
                ...taskData,
                description: JSON.stringify(convertToRaw(editorState.getCurrentContent())),
                subTasks: subTasksPayload
            };
            const response = await AuthApi.createTask(taskPayload);
            swal.close();
            console.log("API response:", response); 
            if (response && response.status) {
                swal("Success", "Task created successfully", "success");
                props.history.push('/tasks');
            } else {
                swal("Error", "Failed to create task", "error");
            }
        } catch (error) {
            swal.close();
            console.error("Error creating task:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    const isSuperAdmin = ls("roles") === "Super Admin";
    // console.log(isSuperAdmin);

    const handleEditorChange = (state) => {
        setEditorState(state);
        setTaskData({ ...taskData, description: state.getCurrentContent().getPlainText() });
    };

    const handleKeyCommand = (command, state) => {
        const newState = RichUtils.handleKeyCommand(state, command);
        if (newState) {
            handleEditorChange(newState);
            return 'handled';
        }
        return 'not-handled';
    };

    const handleAddSubTask = () => {
        if (newSubTask.name.trim() !== '') {
            const subTaskContent = JSON.stringify(convertToRaw(subTaskEditorState.getCurrentContent()));
            setSubTasks([...subTasks, { ...newSubTask, details: subTaskContent }]);
            setNewSubTask({ name: '', status: '' });
            setSubTaskEditorState(EditorState.createEmpty());
            setShowSubTaskFields(false); 
        } else {
            setShowSubTaskFields(true); 
        }
    };

    const uploadImageCallBack = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new window.FileReader();
            reader.onloadend = () => {
                resolve({ data: { link: reader.result } });
            };
            reader.readAsDataURL(file);
        });
    };

    if (pageLoading) {
        return (
            <div>
                <AuthCheckComponent authToken={props.authToken} />
                <Header {...props} authUser={props.authUser} component={<PageLoader />} />
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Tasks"
                                    primaryPageLink="/tasks"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Task" />
                            </CardContent>
                        </Card>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root}>
                                    <CardContent>
                                        <Typography variant="h2">Add Task</Typography>
                                        <form className={classes.form} onSubmit={handleSubmit} >
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="Task"
                                                        name="task"
                                                        label="Task"
                                                        variant="outlined"
                                                        error={formErrors.task && true}
                                                        value={taskData.task}
                                                        onChange={handleChange}
                                                        className={formErrors.task && "input-error"}
                                                    />
                                                    {formErrors.task && (
                                                        <span className="error">{formErrors.task}</span>
                                                    )}
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <FormControl fullWidth variant="outlined" error={!!formErrors.project_name}>
                                                        <InputLabel>Project Name</InputLabel>
                                                        <Select
                                                            name="project_name"
                                                            value={taskData.project_name}
                                                            onChange={handleChange}
                                                            label="Project Name"
                                                        >
                                                            {projects.map((project) => (
                                                                <MenuItem key={project.id} value={project.project_name}>
                                                                    {project.project_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        {formErrors.project_name && <span className="error">{formErrors.project_name}</span>}
                                                    </FormControl>
                                                </Grid>

                                                {isSuperAdmin && ( 
                                                    <Grid item xs={6}>
                                                        <FormControl fullWidth variant="outlined">
                                                            <InputLabel>Developer Name</InputLabel>
                                                            <Select
                                                                name="developer_name"
                                                                value={taskData.developer_name}
                                                                onChange={handleChange}
                                                                label="Developer Name"
                                                            >
                                                                {developers.map((developer) => (
                                                                    <MenuItem key={developer.id} value={developer.firstName}>
                                                                        {developer.firstName}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                )}

                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="Task Date Time"
                                                        name="task_date_time"
                                                        label="Task Deadline Date Time"
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        value={taskData.task_date_time}
                                                        onChange={handleChange}
                                                        error={!!formErrors.task_date_time}
                                                        helperText={formErrors.task_date_time}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </Grid>
                                                {(!isSuperAdmin) && (
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            id="TaskDeliverDate"
                                                            name="task_deliver_date"
                                                            label="Task Deliver Date & Time"
                                                            type="datetime-local"
                                                            variant="outlined"
                                                            value={taskData.task_deliver_date}
                                                            onChange={handleChange}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                )}
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5} style={{ marginTop: "40px" }} >
                                                <Grid item xs={12}>
                                                    <div className={formErrors.description && "input-error"} style={{ border: '1px solid #ccc', padding: '5px', minHeight: '200px' }}>
                                                        <Editor
                                                            editorState={editorState}
                                                            onEditorStateChange={handleEditorChange}
                                                            toolbar={{
                                                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                                inline: { inDropdown: true },
                                                                list: { inDropdown: true },
                                                                textAlign: { inDropdown: true },
                                                                link: { inDropdown: true },
                                                                history: { inDropdown: true },
                                                                image: {
                                                                    uploadCallback: uploadImageCallBack,
                                                                    previewImage: true,
                                                                    alt: { present: true, mandatory: false },
                                                                    inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
                                                                }
                                                            }}
                                                            placeholder="Enter description here..."
                                                        />
                                                    </div>
                                                    {formErrors.description && (
                                                        <span className="error">{formErrors.description}</span>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5} style={{ marginTop: "40px" }} >
                                                <Grid item xs={6}>
                                                    <FormControl fullWidth variant="outlined" error={!!formErrors.status}>
                                                        <InputLabel>Status</InputLabel>
                                                        <Select
                                                            name="status"
                                                            value={taskData.status}
                                                            onChange={handleChange}
                                                            label="Status"
                                                        >
                                                            <MenuItem value="Done">Done</MenuItem>
                                                            <MenuItem value="Pending">Pending</MenuItem>
                                                            <MenuItem value="In Progress">In Progress</MenuItem>
                                                            <MenuItem value="Need to Discuss">Need to Discuss</MenuItem>
                                                            <MenuItem value="Testing">Testing</MenuItem>
                                                        </Select>
                                                        {formErrors.status && <span className="error">{formErrors.status}</span>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={5} style={{ marginTop: "40px" }} >
                                                <Grid item xs={6}>
                                                    <Button 
                                                        onClick={() => setShowSubTasks(!showSubTasks)} 
                                                        variant="contained" 
                                                        color="primary" 
                                                        style={{ marginBottom: "15px", left: '350px' }}
                                                    >
                                                        {showSubTasks ? "Hide Sub Tasks" : "Show Sub Tasks"}
                                                    </Button>
                                                    {showSubTasks && (
                                                        <>
                                                            <Tooltip title="Add Sub Tasks">
                                                                <Button 
                                                                    onClick={handleAddSubTaskField} 
                                                                    variant="contained" 
                                                                    color="primary" 
                                                                    style={{ marginBottom: "15px", left: '355px', top: '0px' }}
                                                                >
                                                                    <AddIcon />
                                                                </Button>
                                                            </Tooltip>
                                                            {subTaskFields.map((subTask, index) => (
                                                                <div key={index} style={{ marginBottom: '20px', position: 'relative', width: '160%' }}>
                                                                    <Grid container spacing={2}>
                                                                        <Grid item xs={6}>
                                                                            <TextField
                                                                                fullWidth
                                                                                id={`SubTask-${index}`}
                                                                                name="subTask"
                                                                                label="Sub Task"
                                                                                variant="outlined"
                                                                                value={subTask.name}
                                                                                onChange={(e) => handleSubTaskFieldChange(index, 'name', e.target.value)}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={6}>
                                                                            <FormControl fullWidth variant="outlined">
                                                                                <InputLabel>Sub Task Status</InputLabel>
                                                                                <Select
                                                                                    value={subTask.status}
                                                                                    onChange={(e) => handleSubTaskFieldChange(index, 'status', e.target.value)}
                                                                                    label="Sub Task Status"
                                                                                >
                                                                                    <MenuItem value="Done">Done</MenuItem>
                                                                                    <MenuItem value="Pending">Pending</MenuItem>
                                                                                    <MenuItem value="In Progress">In Progress</MenuItem>
                                                                                    <MenuItem value="Need to Discuss">Need to Discuss</MenuItem>
                                                                                    <MenuItem value="Testing">Testing</MenuItem>
                                                                                </Select>
                                                                            </FormControl>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <div style={{ border: '1px solid #ccc', padding: '5px', minHeight: '200px', marginTop: '10px' }}>
                                                                        <Editor
                                                                            editorState={subTask.editorState}
                                                                            onEditorStateChange={(state) => handleSubTaskEditorChange(index, state)}
                                                                            toolbar={{
                                                                                options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
                                                                                inline: { inDropdown: true },
                                                                                list: { inDropdown: true },
                                                                                textAlign: { inDropdown: true },
                                                                                link: { inDropdown: true },
                                                                                history: { inDropdown: true },
                                                                            }}
                                                                            placeholder="Enter sub-task details here..."
                                                                        />
                                                                    </div>
                                                                    <Button
                                                                        onClick={() => handleRemoveSubTaskField(index)}
                                                                        variant="contained"
                                                                        style={{ position: 'absolute', top: '110px', right: '-290px', color:'white',backgroundColor:'red' }}
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid container className={classes.root} spacing={3} style={{ marginTop: "49px" }}>
                                                <Grid item xs={4} style={{ display: 'flex' }}>
                                                    <Button type="submit" className="btn-success" style={{ marginTop: "10px" }} variant="contained" color="primary" disabled={submitLoading}>
                                                        {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                    </Button>

                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px" }} disabled={submitLoading} onClick={(e) => { e.preventDefault(); props.history.push('/tasks') }}>Cancel</Button>
                                                </Grid>
                                                <Grid item xs={4}></Grid>
                                                <Grid item xs={4}></Grid>
                                            </Grid>
                                        </form>

                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={6}></Grid>
                        </Grid>
                    </div>
                } />
            <Footer />
        </div>
    )
}

export default CreateTask; 
